export default {
  title: 'THE PAGE YOU’RE LOOKING FOR MUST BE HERE SOMEWHERE...',
  description: 'Are you looking for one of the pages below?',
  not_found: "We can't find the url you entered. Please check if it was entered correctly.",
  no_restaurants: {
    title: "This shop isn't open for online orders yet",
    description: 'Please check back soon.',
  },
  toasts: {
    failed_to_load_stores: 'Failed to load stores, please refresh the page',
  },
};
